import styled from "styled-components";
import { trodlyFontMedium, trodlyBlack } from "../styles/Constants";

export const Title = styled.h1`
  font-size: ${ props => props.size};
  color: ${props => props.color};
  font-weight: ${props => props.weight};
  margin: ${props => props.margin};
  text-align: ${props => props.align};
  width: ${props => props.width};
`;



Title.defaultProps = {
    size: "1.5rem",
    color: trodlyBlack,
    weight: trodlyFontMedium,
    margin: "0 0 0.8rem",
    align: 'left',
    width: 'initial'
}
